export default __webpack_public_path__ + "static/media/pakai-masker.a25192db.png";